import { Injectable } from '@angular/core';

export interface ExclusiveDropdown {
  closeDropdown(): void;
}

@Injectable({ providedIn: 'root' })
export class ExclusiveDropdownService {
  private active: ExclusiveDropdown | null = null;

  open(dropdown: ExclusiveDropdown): void {
    if (this.active && this.active !== dropdown) {
      this.active.closeDropdown();
    }
    this.active = dropdown;
  }

  closed(dropdown: ExclusiveDropdown): void {
    if (this.active === dropdown) {
      this.active = null;
    }
  }
}
